// AdminEmailJobTable component styles
export const tableComponentStyles = {
	mainContainer: {
		backgroundColor: (theme) => theme.palette.background.paper,
    color: (theme) => theme.palette.text.primary,
		display: 'flex',
		flexDirection: 'column',
		padding: '24px',
		borderRadius: '8px',
		boxShadow: '0 1px 5px rgba(0, 0, 0, 0.1)',
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		mb: 2,
	},
	filtersContainer: {
		display: 'flex',
		gap: 2,
	},
	dataGridContainer: {
		width: '100%',
	},
};

// DataGrid styles
export const dataGridStyles = {
	'--DataGrid-containerBackground': 'background.paper',
	'& .capitalize-text': {
		textTransform: 'capitalize',
	},
	'& .MuiDataGrid-columnHeader': {
		backgroundColor: 'background.paper',
	},
	'& .MuiDataGrid-columnHeaderTitle': {
		fontWeight: 600,
	},
	'& .MuiDataGrid-row': {
		backgroundColor: 'background.paper !important',

		'&:hover': {
			backgroundColor: 'action.hover !important',
		},
	},
	'& .MuiDataGrid-row--even': {
		backgroundColor: 'background.paper !important',
	},
	'& .MuiDataGrid-row--odd': {
		backgroundColor: 'background.paper !important',
	},
	'& .MuiDataGrid-cell': {
		backgroundColor: 'transparent',
	},
	border: (theme) => `1px solid ${theme.palette.divider}`,
	borderRadius: 0,
	'& .MuiDataGrid-footerContainer': {
		borderTop: (theme) => `1px solid ${theme.palette.divider}`,
		backgroundColor: 'background.paper',
		minHeight: '52px',
	},
};
